<template>
  <BaseButton primary outline small @click="open"> Email Reviewers </BaseButton>
</template>

<script>
export default {
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async open() {
      this.$modal.show({
        component: () => import('Components/ProjectAssets/EmailReviewersModal.vue'),
        props: {
          project: this.project,
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
